export const crudCommonMixin = {
    props: {
        /**
         * Name of the entity
         */
        entityName: {
            type: String,
            required: true
        },
        /**
         * Localisation section name used for texts
         */
        locoSection: {
            type: String,
            default: null
        },
        /**
         * Do not use name property in table and dialog.
         */
        noNameProp: {
            type: Boolean,
            default: false
        },
        /**
         * Vuex store api namespace
         */
        apiNs: {
            type: String,
            default: null
        },
        /**
         * Function to get name from entity
         */
        itemNameFn: {
            type: Function,
            default: (item) => item.name
        }
    },
    computed: {
        ns() {
            return this.apiNs ? this.apiNs + '/' : '';
        },
        entityNameParts() {
            return this.entityName.split(/(?=[A-Z])/).map(s => s.toLowerCase());
        },
        localizationSectionName() {
            return this.locoSection || this.entityNameParts.join("_");
        },
        capitalizedEntityName() {
            return this.capitalizeString(this.entityName);
        },
        eventEntityName() {
            return this.entityNameParts.join("-");
        },
        entityNameInContext() {
            return this.entityNameParts.join(" ");
        }
    },
    methods: {
        capitalizeString(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        },
    }
};